function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.99 5H16V3H3.99V0L0 4l3.99 4V5z",
  fill: "#005646"
});

function SvgGoBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGoBackArrow;